module.exports = __webpack_public_path__ + "img/symbol_14.9cc08b66.png";